//*********************     USERs ACTIONS    ****************************** */
var TypeSpace = '___STORAGE'
export const GET_ONE_SUCCESS = 'GET_ONE_SUCCESS' + TypeSpace
export const UPLOAD_SUCCESS = 'UPLOAD_SUCCESS' + TypeSpace
export const DELETE_SUCCESS = 'DELETE_SUCCESS' + TypeSpace
